var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({attrs:{"fab":"","dark":"","x-small":"","color":"primary","title":_vm.$i18n.t(_vm.title)}},_vm.$listeners),[_c('v-icon',{staticClass:"title"},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }